export default {
  eventTemplateSettingsTitleContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  eventTemplateSettingsTitle: { flex: 1 },
  eventTemplateSettingsActionsContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  search: { marginLeft: '1rem' },
};
